//
// Connection.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "./Server";
import "../media/UserInfo";
import "../media/particles/LogonStatus";
import "../media/particles/EsriLogonStatus";
import "../media/particles/EsriPortalLogonStatus";
import "../media/particles/ReportImageSize";
import "../media/ReportSchemaVersion";
import "../../depot/FeatureFlag";

var Connection = createModule("transport_Connection", [130,13,50372,50092], EventDispatcher, [
    ,
    {
        server: 1,
        userInfo: 1,
        reportSchemaVersion: 1,
        authToken: 7,
        description: 7,
        uuid: 7,
        useGuestCredentials: 2,
        password: 7,
        overrideReportImageSizes: 2,
        reportSectionImageDefaultSize: 4,
        featureFlags: [1],
        esriLogonStatus: 4,
        reportImageDefaultSize: 4,
        initialServerUserId: 7,
        logonStatus: 4,
        userId: 7,
        esriPortalLogonStatus: 4,
        passwordKey: 7,
        isLocal: 2,
        lastSuccessfulLogon: 9,
        credentialStorageVersion: 4,
        reportImageSizes: [4],
        sasLogonApiMeta: 7,
        shouldAutoConnect: 2,
        sessionToken: 7,
        lastSuccessfulServerCommunication: 9,
        reportSectionImageSizes: [4],
        useEsriPremiumServices: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Connection;
